import { render, staticRenderFns } from "./BitrixLead.vue?vue&type=template&id=4418645e&scoped=true"
import script from "./BitrixLead.vue?vue&type=script&lang=js"
export * from "./BitrixLead.vue?vue&type=script&lang=js"
import style0 from "./BitrixLead.vue?vue&type=style&index=0&id=4418645e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4418645e",
  null
  
)

export default component.exports